


















import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';

@Component({})
export default class AmountField extends Vue {
  private tooltip: string = '';
  @Prop()
  private value!: number | null;
  @Prop({default: 1})
  private min!: number;
  @Prop({default: null})
  private max!: number | null;
  @Prop({default: 1})
  private step!: number;
  @Prop({default: null})
  private appendClass!: string | JSON | null;
  @Prop({default: false})
  private disabled!: boolean;
  @Prop({default: true})
  private defaultStyle!: boolean;
  @Prop({default: false})
  private readonly!: boolean;

  private alert: boolean = false;

  private style(): any {
    const style: any = {
      disabled: this.disabled,
      alert: this.alert,
      amountfield: this.defaultStyle,
    };
    if (!this.appendClass) {
      return style;
    }
    if (typeof this.appendClass === 'string') {
      style[this.appendClass] = true;
      return style;
    }
    return Object.assign(style, this.appendClass);
  }

  @Emit('input')
  private update(event: Event): number | null {
    this.alert = false;
    const target = event.target as HTMLInputElement;

    if (!target.validationMessage) {
      return Number(target.value);
    }

    this.alert = true;
    this.tooltip = target.validationMessage;

    return Number(target.value);
  }

  @Emit('changed')
  private changed(event: Event): Event {
    return event;
  }

  @Emit('keydown-enter-prevent')
  private keydown(event: Event): Event {
    return event;
  }
 }
